import { SessionManagerState, sessionManagerState } from './State'

import {
  SET_CURRENT_USER,
  SET_IS_LOADING_CURRENT_USER,
  SET_IS_MOUNTED,
  EXECUTE_LOGOUT,
  SET_CALLBACK_URL,
  SessionManagerAction
} from './Actions'

function sessionManagerResult(state: SessionManagerState, action: SessionManagerAction): SessionManagerState {
  switch (action.type) {
    case SET_CURRENT_USER:
      return Object.assign({}, state, {
        currentUser: action.payload,
        isLoadingCurrentUser: false
      })
    case SET_IS_LOADING_CURRENT_USER:
      return Object.assign({}, state, { isLoadingCurrentUser: action.payload })
    case SET_IS_MOUNTED:
      return Object.assign({}, state, { isMounted: action.payload })
    case SET_CALLBACK_URL:
      return Object.assign({}, state, { callbackUrl: action.payload })
    case EXECUTE_LOGOUT:
      return Object.assign({}, state, {
        currentUser: null,
        isLoadingCurrentUser: false
      })
    default:
      return sessionManagerState
  }
}

export default sessionManagerResult
